export default __webpack_public_path__ + "static/media/payment-icon.dfa8abb9.webp";